import React from 'react';

import Modal from '@ott/modal';
import LoadingDots from '@ott/loading-dots';

import styles from './LoadingModal.scss';

type Props = {
  isOpen: boolean;
};

const LoadingModal = ({ isOpen }: Props) => {
  return (
    <Modal isOpen={isOpen} specificLocators="loading-modal" preventUserClose={true}>
      <div className={styles.wrapper}>
        <LoadingDots />
      </div>
    </Modal>
  );
};

export default React.memo(LoadingModal);
